import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { EntityDocumentStatusList } from './List/List';


export { EntityDocumentStatusList, };


export const entityDocumentStatusResource = {
	list: EntityDocumentStatusList,	
	icon: AssignmentTurnedInIcon,
};
